import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight, Smartphone, Handshake } from "lucide-react";
import beraStaysLogo from "@/assets/berastays-logo.png";
import expressPayImg from "@/assets/Expresspay.png";
import referenciaImg from "@/assets/Rerencia.png";
import pay4AllImg from "@/assets/Pay4all.jpg";
import visaImg from "@/assets/Visa.png";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";

import { tAuto } from "@/lib/tAuto";
const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const XIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

/* Store Badges - Built with HTML/CSS for pixel-perfect text */
const AppStoreBadge = () => (
  <div className="flex items-center gap-2.5 h-11 px-4 rounded-lg bg-black border border-white/20 hover:border-white/40 transition-colors cursor-pointer select-none">
    <svg viewBox="0 0 24 24" className="w-6 h-6 shrink-0" fill="white">
      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
    </svg>
    <div className="flex flex-col gap-0.5">
      <span className="text-white/80 text-[9px] font-normal tracking-wide leading-none">Baixar na</span>
      <span className="text-white text-[15px] font-semibold tracking-tight leading-none">App Store</span>
    </div>
  </div>
);

const GooglePlayBadge = () => (
  <div className="flex items-center gap-2.5 h-11 px-4 rounded-lg bg-black border border-white/20 hover:border-white/40 transition-colors cursor-pointer select-none">
    <svg viewBox="0 0 24 24" className="w-5 h-5 shrink-0">
      <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92z" fill="#4285F4"/>
      <path d="M17.556 8.474L5.414.705a1.002 1.002 0 0 0-1.005-.014l9.189 9.189 3.958-1.406z" fill="#32A071"/>
      <path d="M20.854 10.633l-3.297-1.868-4.165 3.235 4.165 4.165 3.297-1.867c.934-.527.934-1.86 0-2.387v-1.278z" fill="#FFC107"/>
      <path d="M3.61 22.186a1 1 0 0 0 1.005-.014l12.142-7.768L13.6 12 3.609 22.186z" fill="#F44336"/>
    </svg>
    <div className="flex flex-col gap-0.5">
      <span className="text-white/80 text-[9px] font-normal tracking-wide leading-none">{tAuto("auto.components_layout_footer.1", "Disponível no")}</span>
      <span className="text-white text-[15px] font-semibold tracking-tight leading-none">Google Play</span>
    </div>
  </div>
);

interface FooterProps {
  showPaymentMethods?: boolean;
}

const Footer = ({ showPaymentMethods = false }: FooterProps) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    plataforma: [
      { label: t('nav.explore'), href: "/explorar" },
      { label: t('nav.host'), href: "/anunciar" },
      { label: t('nav.makeOffer'), href: "/ofertas/nova" },
    ],
    suporte: [
      { label: t('footer.help'), href: "/ajuda" },
      { label: t('footer.cancellation'), href: "/termos" },
      { label: t('footer.privacy'), href: "/privacidade" },
    ],
    interno: [
      { label: t('footer.insurerArea', { defaultValue: 'Área da Seguradora' }), href: "/seguradora/login" },
    ],
  };

  const socialLinks = [
    { icon: FacebookIcon, href: "https://facebook.com/berastays", label: "Facebook" },
    { icon: InstagramIcon, href: "https://instagram.com/berastays", label: "Instagram" },
    { icon: XIcon, href: "https://x.com/berastays", label: "X" },
    { icon: LinkedInIcon, href: "https://linkedin.com/company/berastays", label: "LinkedIn" },
  ];

  return (
    <footer className="gradient-footer text-white relative overflow-hidden">
      {/* Subtle pattern */}
      <div className="absolute inset-0 pattern-african opacity-[0.02]" />
      <div className="absolute inset-0 bg-gradient-to-b from-white/[0.06] via-black/10 to-black/40" />
      
      <div className="container mx-auto px-6 relative z-10">
        {/* Affiliate CTA Strip */}
        <div className="py-4 border-b border-white/[0.08]">
          <Link 
            to="/afiliados"
            className="group flex items-center justify-between p-5 rounded-2xl bg-gradient-to-r from-bera-gold/15 via-primary/10 to-bera-gold/15 border border-bera-gold/20 hover:border-bera-gold/40 transition-all duration-300"
          >
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-xl bg-white/10 border border-white/10 flex items-center justify-center">
                <Handshake className="w-5 h-5 text-white/80" strokeWidth={1.5} />
              </div>
              <div>
                <p className="font-display text-sm font-semibold text-white tracking-wide">
                  {t('footer.affiliateProgram')}
                </p>
                <p className="text-white/50 text-xs mt-0.5">
                  {t('footer.affiliateDescription')}
                </p>
              </div>
            </div>

            <div className="hidden sm:flex items-center gap-2 text-white/70 group-hover:text-white transition-colors text-xs font-semibold tracking-wide">
              <span>{t('common.viewAll')}</span>
              <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
            </div>
          </Link>
        </div>

        {/* Main Grid */}
        <div className="py-6 grid grid-cols-2 md:grid-cols-12 gap-6 lg:gap-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-3">
            <Link to="/" className="inline-block mb-4">
              <img src={beraStaysLogo} alt="BeraStays" className="h-20 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity" />
            </Link>
            <p className="text-white/50 text-[13px] leading-relaxed max-w-xs mb-5">
              {t('footer.description')}
            </p>
            <div className="space-y-2 mb-6">
              <a href="mailto:info@berachatech.it.ao" className="flex items-center gap-2.5 text-white/45 hover:text-white/80 transition-colors text-[13px]">
                <Mail className="w-3.5 h-3.5" strokeWidth={1.5} />
                <span>info@berachatech.it.ao</span>
              </a>
              <a href="tel:+244940235770" className="flex items-center gap-2.5 text-white/45 hover:text-white/80 transition-colors text-[13px]">
                <Phone className="w-3.5 h-3.5" strokeWidth={1.5} />
                <span>+244 940 235 770</span>
              </a>
              <a href="tel:+244931362321" className="flex items-center gap-2.5 text-white/45 hover:text-white/80 transition-colors text-[13px]">
                <Phone className="w-3.5 h-3.5" strokeWidth={1.5} />
                <span>+244 931 362 321</span>
              </a>
              <div className="flex items-center gap-2.5 text-white/45 text-[13px]">
                <MapPin className="w-3.5 h-3.5" strokeWidth={1.5} />
                <span>Luanda, Angola</span>
              </div>
            </div>
          </div>

          {/* Platform Links */}
          <div className="col-span-1 md:col-span-2">
            <h4 className="text-[11px] font-semibold mb-4 text-white/70 tracking-[0.2em] uppercase font-sans">
              {t('footer.platform')}
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.plataforma.map((link) => (
                <li key={link.href}>
                  <Link to={user ? link.href : "/auth"} className="text-white/45 hover:text-white transition-colors text-[13px]">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div className="col-span-1 md:col-span-2">
            <h4 className="text-[11px] font-semibold mb-4 text-white/70 tracking-[0.2em] uppercase font-sans">
              {t('footer.support')}
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.suporte.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-white/45 hover:text-white transition-colors text-[13px]">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Internal Links */}
          <div className="col-span-1 md:col-span-2">
            <h4 className="text-[11px] font-semibold mb-4 text-white/70 tracking-[0.2em] uppercase font-sans">
              Interno
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.interno.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-white/45 hover:text-white transition-colors text-[13px]">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* App Download + Social */}
          <div className="col-span-2 md:col-span-3">
            <h4 className="text-[11px] font-semibold mb-4 text-white/70 tracking-[0.2em] uppercase font-sans">
              <span className="inline-flex items-center gap-2">
                <Smartphone className="w-3.5 h-3.5 text-white/60" strokeWidth={1.75} />
                <span>{t('footer.downloadApp')}</span>
              </span>
            </h4>
            <p className="text-white/40 text-xs mb-4 leading-relaxed">
              {t('footer.appDescription')}
            </p>
            
            {/* App Store Badges */}
            <div className="flex flex-wrap gap-3 mb-6">
              <motion.a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex rounded-lg overflow-hidden border border-white/10 hover:border-white/25 transition-all bg-white/[0.04] hover:bg-white/[0.08] backdrop-blur-sm"
                whileHover={{ scale: 1.03, y: -2 }}
                whileTap={{ scale: 0.97 }}
                aria-label={t('footer.downloadAppStore')}
              >
                <AppStoreBadge />
              </motion.a>
              <motion.a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex rounded-lg overflow-hidden border border-white/10 hover:border-white/25 transition-all bg-white/[0.04] hover:bg-white/[0.08] backdrop-blur-sm"
                whileHover={{ scale: 1.03, y: -2 }}
                whileTap={{ scale: 0.97 }}
                aria-label={t('footer.downloadGooglePlay')}
              >
                <GooglePlayBadge />
              </motion.a>
            </div>

            {/* Social */}
            <h4 className="text-[11px] font-semibold mb-3 text-white/70 tracking-[0.2em] uppercase font-sans">
              {t('footer.followUs')}
            </h4>
            <div className="flex gap-2">
              {socialLinks.map((social) => (
                <motion.a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-xl bg-white/[0.06] hover:bg-white/[0.12] flex items-center justify-center transition-all"
                  aria-label={social.label}
                  whileHover={{ y: -2 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <social.icon />
                </motion.a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Payment Methods - Landing Page Only */}
      {showPaymentMethods && (
        <div className="border-t border-white/[0.06]">
          <div className="container mx-auto px-6 py-5 flex flex-col items-center justify-center">
            <p className="text-white/40 text-[10px] font-medium tracking-[0.18em] uppercase mb-4">
              {t('footer.paymentMethods', { defaultValue: 'Métodos de Pagamento' })}
            </p>
            <div className="rounded-2xl bg-white/[0.05] border border-white/10 backdrop-blur-sm px-6 py-4 hover:bg-white/[0.08] transition-colors duration-300 flex items-center justify-center gap-4 sm:gap-5 flex-wrap">
              <div className="bg-white/95 hover:bg-white px-3 py-1.5 rounded-xl shadow-sm hover:scale-105 transition-all">
                <img
                  src={expressPayImg}
                  alt="Multicaixa Express"
                  className="h-6 sm:h-7 w-auto object-contain"
                />
              </div>
              <div className="w-px h-6 bg-white/10 hidden sm:block" />
              <div className="bg-white/95 hover:bg-white px-3 py-1.5 rounded-xl shadow-sm hover:scale-105 transition-all">
                <img
                  src={referenciaImg}
                  alt={tAuto("auto.components_layout_footer.2", "Pagamento por Referência")}
                  className="h-6 sm:h-7 w-auto object-contain"
                />
              </div>
              <div className="w-px h-6 bg-white/10 hidden sm:block" />
              <div className="bg-white/95 hover:bg-white px-3 py-1.5 rounded-xl shadow-sm hover:scale-105 transition-all">
                <img
                  src={pay4AllImg}
                  alt="Pay4All"
                  className="h-6 sm:h-7 w-auto object-contain mix-blend-multiply"
                />
              </div>
              <div className="w-px h-6 bg-white/10 hidden sm:block" />
              <div className="bg-white/95 hover:bg-white px-3 py-1.5 rounded-xl shadow-sm hover:scale-105 transition-all">
                <img
                  src={visaImg}
                  alt="Visa / Mastercard"
                  className="h-6 sm:h-7 w-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Bottom Bar */}
      <div className="border-t border-white/[0.06]">
        <div className="container mx-auto px-6 py-3 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-white/35 text-xs text-center sm:text-left">
            {t('footer.copyright', { year: currentYear })}
          </p>
          <p className="text-white/25 text-[11px] flex items-center gap-1">
            {t('footer.madeWithLove')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
